import type { ComponentProps } from 'react'
import React from 'react'

import { Icon } from '@fourthwall/components'

import * as S from './IconButton.styled'

type IconButtonProps = Omit<ComponentProps<typeof Icon>, 'height'> & {
  className?: string
  onClick?: () => void
  height?: number
}

export const IconButton = ({ className, height = 20, onClick, ...props }: IconButtonProps) => {
  return (
    <S.Button className={className} onClick={onClick}>
      <Icon height={height} {...props} />
    </S.Button>
  )
}
